import {Moment} from 'moment';
import {ICustomer} from './customer.model';
// import {IUser} from "../../core/user/user.model";
import {IOrderObject} from "./order-object.model";
import {IOrganization} from "./organization.model";
import {IEmployee} from "./employee.model";
import {IContract} from "./contract.model";
import {IProject} from "./project.model";


export interface IRapidCustomer {
  id?: number;
  itemName?: string;
  status?: string;
  type?: string;
  description?: string;
  customer_title?: string;
  customer_id?: string;
  customer_connector?: string;
  customer_type?: string;
  firstName?: string;
  lastName?: string;
  gender?: string;
  prefix?: string;
  firstName_phone?: string;
  lastName_phone?: string;
  gender_phone?: string;
  prefix_phone?: string;
  priority?: string;
  customer_address?: string;
  customer_city?: string;
  customer_state?: string;
  customer_fieldActivity?: string;
  project_address?: string;
  project_stage?: string;
  phone_number?: string;
  phone_type?: string;
  cycle_type?: string;
  deadline?: boolean;
  expiratioDate?: Moment;
  action?: string;
  actionFollow?: string;
  actionDate?: any;
  audience?: string;
  position?: string;
  jalaliDate?: string;
  jalaliDateFollow?: string;
  followupby?: number;
  followupbyS?: string;
  followupbyDate?: Moment;
  followupbyAudience?: string;
  step?: string;
  step_number?: any;
  salesCycle_title?: any;
  followupbyDescription?: string;
  createby?: number;
  createdBy?: any;
  createbyS?: string;
  createDate?: Moment;
  customer?: ICustomer;
  orderObject?: IOrderObject;
  reminderMe_time?: string;
  reminderMe_type?: string;
  reminderMe?: boolean;
  // user_fk?: IUser;
  userId?: any;
  employee_str?: any;
  employee?: IEmployee;
  contract?: IContract;
  project?: IProject;
  contract_str?: any;
  project_str?: any;
  organization?: IOrganization;
  lastModifiedDate?: any;
  createdDate?: any;
}

export class RapidCustomer implements IRapidCustomer {
  constructor(public id?: number,
              public itemName?: string,
              public status?: string,
              public type?: string,
              public firstName?: string,
              public lastName?: string,
              public gender?: string,
              public prefix?: string,
              public firstName_phone?: string,
              public lastName_phone?: string,
              public gender_phone?: string,
              public prefix_phone?: string,
              public priority?: string,
              public createdBy?: any,
              public description?: string,
              public deadline?: boolean,
              public expiratioDate?: Moment,
              public actionFollow?: string,
              public action?: string,
              public cycle_type?: string,
              public reminderMe_time?: string,
              public reminderMe_type?: string,
              public reminderMe?: boolean,
              public actionDate?: Moment,
              public audience?: string,
              public position?: string,
              public jalaliDate?: string,
              public jalaliDateFollow?: string,
              public followupby?: number,
              public followupbyS?: string,
              public followupbyDate?: Moment,
              public followupbyAudience?: string,
              public step?: string,
              public step_number?: any,
              public followupbyDescription?: string,
              public createby?: number,
              public createbyS?: string,
              public createDate?: Moment,
              public employee?: IEmployee,
              public customer?: ICustomer,
              public orderObject?: IOrderObject,
              public contract?: IContract,
              public project?: IProject,
              public userId?: string,
              public customer_type?: string,
              public employee_str?: any,
              public contract_str?: any,
              public project_str?: any,
              public lastModifiedDate?: any,
              public createdDate?: any,
              public organization?: IOrganization) {
    this.deadline = this.deadline || false;
    this.customer_type= 'حقیقی';

  }
}
